import { Box, CopyButton, FlexColBox } from "../../../common/components";
import { Typography } from "@mui/material";
import ColorBox from "../../../common/components/Select/ColorSelect/ColorBox/ColorBox";
import { palette } from "../../../styles/theme";

interface Props {
  colorHex?: string;
  chartName: string;
  label?: string;
  techpackName: string;
}

const ArtworkCustomColor = ({
  chartName,
  label,
  techpackName,
  colorHex,
}: Props) => {
  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <ColorBox colorOrCombo={colorHex || ""} />
      <FlexColBox>
        <Typography variant="textSm" color={palette.grey.primary}>
          {`${chartName} - ${label} ${techpackName ? `(${techpackName})` : ""}`}
        </Typography>
        <Box display="flex" alignItems="center">
          <Typography variant="textSm" color={palette.grey.primary}>
            {colorHex}
          </Typography>
          <CopyButton
            value={colorHex?.split("#")[1] || ""}
            sx={{ ml: "4px" }}
          />
        </Box>
      </FlexColBox>
    </Box>
  );
};

export default ArtworkCustomColor;
